import { DownloadOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React from 'react';
import { useDownloadFile } from '../hooks/useDownloadFile';
import { useInteractDownloadFile } from '../hooks/useInteractDownloadFile';
import { IFileActionButtonProps, useFileAction } from '../hooks/useFileAction';

export type IDownloadFileProps = IFileActionButtonProps;

const DownloadFile: React.FC<IDownloadFileProps> = ({
  fileId,
  filePath,
  file,
  modelInstanceId,
  label,
  icon = <DownloadOutlined />,
  type = 'primary',
  variant = 'solid',
  size = 'middle',
  className,
  style,
  onClick,
  disabled,
  loading,
}) => {
  const {
    downloadFile: downloadCoreFile,
    isDownloadingFile: isDownloadingCoreFile,
  } = useDownloadFile();

  const {
    downloadFile: downloadInteractFile,
    isDownloadingFile: isDownloadingInteractFile,
  } = useInteractDownloadFile();

  const fileIdValue = file?.id || fileId;
  const filePathValue = file?.path || filePath;

  const { isLoading, isDisabled, handleClick } = useFileAction({
    fileId: fileIdValue,
    filePath: filePathValue,
    modelInstanceId,
    onClick,
    disabled,
    loading,
    isLoadingCore: isDownloadingCoreFile,
    isLoadingInteract: isDownloadingInteractFile,
    onCoreAction: downloadCoreFile,
    onInteractAction: downloadInteractFile,
  });

  return (
    <Button
      icon={icon}
      type={type}
      variant={variant}
      size={size}
      className={className}
      style={style}
      onClick={handleClick}
      disabled={isDisabled}
      loading={isLoading}
    >
      {label}
    </Button>
  );
};

export default DownloadFile;
